import { render, staticRenderFns } from "./CourtWindingUp.vue?vue&type=template&id=50175307&scoped=true&"
import script from "./CourtWindingUp.vue?vue&type=script&lang=js&"
export * from "./CourtWindingUp.vue?vue&type=script&lang=js&"
import style0 from "./CourtWindingUp.vue?vue&type=style&index=0&id=50175307&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50175307",
  null
  
)

export default component.exports